export default function updateDomainReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_DOMAIN_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_DOMAIN_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_DOMAIN_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}